import axiosProtected from "../config/baseWithToken";

// Branded tracking page of the current store (backend: /store/tracking-page)

export const fetchTrackingPage = async () => {
  const { data } = await axiosProtected.get("/store/tracking-page");
  return data;
};

export const saveTrackingPage = async (settings) => {
  const { data } = await axiosProtected.put("/store/tracking-page", settings);
  return data;
};

export const previewTrackingPage = async (settings, trackingNumber) => {
  const { data } = await axiosProtected.post("/store/tracking-page/preview", {
    settings,
    tracking_number: trackingNumber || undefined,
  });
  return data;
};

export const errorMessage = (e, fallback) =>
  e?.response?.data?.message || fallback;
